
























































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import numeral from 'numeral';
import uniq from 'lodash/uniq';

import { STORE_KEY, store } from './_store';

import ShiftVDPJournalForm from './ShiftVDPJournalForm/ShiftVDPJournalForm.vue'
import ShiftWashJournalForm from '../ShiftWashJournalForm/ShiftWashJournalForm.vue'

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError',
      'meta',
      'relatedFactsList',

      // 'document', 'meta'
    ]),
    ...mapState('ubic', [
      'token', 'user'
    ]),
    ...mapGetters(STORE_KEY, [
      'remainsById', 'totals', 'rotateJournal'
    ]),
    ...mapGetters('ubic', [
      'isAdmin'
    ]),
  },
  components: {
    ShiftVDPJournalForm
  }
})
export default class ShiftVDPJournal extends Vue {

  @Prop() documentId!: string;

  opened: any[] = [];
  public dropFiles = [];

  FILES_HOST = process.env.VUE_APP_UBIC_SERVER_ADDRESS;

  // items: any[] = [];

  formatNumber(value: any) {
    return numeral(value).format('0,0');
  }

  openDocument(row: any) {
    this.$buefy.modal.open({
      component: ShiftVDPJournalForm,
      props: {
        isNew: !row || !row.id,
        documentPreview: row,
        documentId: this.documentId,
        initParams: {}
      },
      events: {
        'form-close': () => {
          this.handleParamsChange();
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form short-form',
      parent: this
    })
  }

  openWashDocument(row: any) {
    this.$buefy.modal.open({
      component: ShiftWashJournalForm,
      props: {
        isNew: !row || !row.id,
        documentPreview: row,
        documentId: this.documentId,
        initParams: {}
      },
      events: {
        'form-close': () => {
          this.handleParamsChange();
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form short-form',
      parent: this
    })
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    } else {
      this.$store.dispatch(`${STORE_KEY}/reset`)
    }
  }

  public mounted() {
    this.handleParamsChange();
  }

  public exportAsXLSX() {
    this.$store.dispatch(`${STORE_KEY}/exportAsXLSX`, {
      documentId: this.documentId,
    });
  }

  public handleParamsChange() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, {
      documentId: this.documentId,
    });
  }
}

